<script setup>
import { Menu, MenuItems } from "@headlessui/vue";
import { twMerge } from "tailwind-merge";
import { computed } from "vue";
import { FormDropdownTrigger } from ".";

const props = defineProps({
    z: {
        type: Number,
        default: 0,
    },
    position: {
        type: String,
        default: "left",
    },
    class: String,
});

const itemsClasses = computed(() => {
    let classes = ["w-56 max-h-60 overflow-auto absolute z-20 mt-2 ring-opacity-5 text-sm rounded-md ring-1 shadow-lg focus:outline-none"];

    classes.push("bg-white ring-black");

    switch (props.position) {
        case "left":
            classes.push("right-0 origin-top-right");
            break;
        case "right":
            classes.push("left-0 origin-top-left");
            break;
    }

    switch (props.z) {
        case 3:
            classes.push("dark:bg-gray-600 dark:ring-gray-500");
            break;
        case 2:
            classes.push("dark:bg-gray-700 dark:ring-gray-600");
            break;
        case 1:
            classes.push("dark:bg-gray-800 dark:ring-gray-700");
            break;
        default:
            classes.push("dark:bg-gray-900 dark:ring-gray-800");
            break;
    }

    return twMerge(classes, props.class);
});
</script>

<template>
    <Menu as="div" class="relative">
        <slot name="trigger">
            <FormDropdownTrigger />
        </slot>

        <transition
            enter-active-class="transition duration-100 ease-out"
            enter-from-class="transform opacity-0 scale-95"
            enter-to-class="transform opacity-100 scale-100"
            leave-active-class="transition duration-75 ease-in"
            leave-from-class="transform opacity-100 scale-100"
            leave-to-class="transform opacity-0 scale-95">
            <MenuItems :class="itemsClasses">
                <slot />
            </MenuItems>
        </transition>
    </Menu>
</template>
